import { connect } from 'react-redux';
import {
  fetchProject,
  setProjectForm,
  deleteProject,
} from '../../../store/modules/project';

import Project from '../components/Project';

const mapActionCreators = {
  fetchProject,
  setProjectForm,
  deleteProject,
};

const mapStateToProps = state => ({
  project: state.project.projects[state.project.current],
  projects: _.filter(state.project.projects, {
    deleted_at: null,
    project_id: null,
  }),
  staffs: state.staff.staffs,
  companies: state.company.companies,
  fetching: state.project.fetching,
  fetchingStaff: state.staff.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Project);



// WEBPACK FOOTER //
// ./src/routes/Project/containers/ProjectContainer.js